module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM5 2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/browser-2.js
// module id = 1026
// module chunks = 14